import { render, staticRenderFns } from "./PageBuilderHeroWidget.vue?vue&type=template&id=485062ba"
import script from "./PageBuilderHeroWidget.vue?vue&type=script&lang=js"
export * from "./PageBuilderHeroWidget.vue?vue&type=script&lang=js"
import style0 from "./PageBuilderHeroWidget.vue?vue&type=style&index=0&id=485062ba&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports